// import { Text } from "@react-three/drei";
// import { fadeOnBeforeCompileFlat } from "../utils/fadeMaterial";

// export const TextSection = ({ title, subtitle, ...props }) => {
//   return (
//     <group {...props}>
//       {!!title && (
//         <Text
//           color="white"
//           anchorX={"left"}
//           anchorY="bottom"
//           fontSize={0.52}
//           maxWidth={2.5}
//           lineHeight={1}
//           font={"./fonts/DMSerifDisplay-Regular.ttf"}
//         >
//           {title}
//           <meshStandardMaterial
//             color={"white"}
//             onBeforeCompile={fadeOnBeforeCompileFlat}
//           />
//         </Text>
//       )}

//       <Text
//         color="white"
//         anchorX={"left"}
//         anchorY="top"
//         fontSize={0.2}
//         maxWidth={2.5}
//         font={"./fonts/Inter-Regular.ttf"}
//       >
//         {subtitle}
//         <meshStandardMaterial
//           color={"white"}
//           onBeforeCompile={fadeOnBeforeCompileFlat}
//         />
//       </Text>
//     </group>
//   );
// };



import { Text } from "@react-three/drei";
import { fadeOnBeforeCompileFlat } from "../utils/fadeMaterial";

const TextSection = ({ title, subtitle, scrolltext, ...props }) => {
  return (
    <group {...props}>
      {!!title && (
        <Text
          color="black"
          anchorX="left"
          anchorY="bottom"
          fontSize={0.52}
          maxWidth={3.7}
          lineHeight={1}
          font="/fonts/DMSerifDisplay-Regular.ttf"
        >
          {title}
          <meshStandardMaterial
            color="black"
            onBeforeCompile={fadeOnBeforeCompileFlat}
          />
        </Text>
      )}

      <Text
        color="black"
        anchorX="left"
        anchorY="top"
        fontSize={0.55}
        maxWidth={3.7}
        font="/fonts/Scratchy.ttf"
        lineHeight={1.1}
        // letterSpacing={-0.1}
      >
        {subtitle}
        <meshStandardMaterial
          color="black"
          onBeforeCompile={fadeOnBeforeCompileFlat}
        />
      </Text>

      <Text
        color="white"
        anchorX="left"
        anchorY="top"
        fontSize={0.45}
        maxWidth={3.7}
        font="/fonts/Scratchy.ttf"
        lineHeight={1.1}
        // letterSpacing={-0.1}
      >
        {scrolltext}
        <meshStandardMaterial
          color="white"
          onBeforeCompile={fadeOnBeforeCompileFlat}
        />
      </Text>
    </group>
  );
};

export default TextSection;
